"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
var Radio_style_1 = __importDefault(require("./Radio.style"));
var Radio = (0, react_1.forwardRef)(function (_a, ref) {
    var checked = _a.checked, children = _a.children, className = _a.className, defaultChecked = _a.defaultChecked, _b = _a.disabled, disabled = _b === void 0 ? false : _b, id = _a.id, label = _a.label, name = _a.name, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, _c = _a.fullWidth, fullWidth = _c === void 0 ? false : _c, _d = _a.unselected, unselected = _d === void 0 ? false : _d, _e = _a.variant, variant = _e === void 0 ? 'standard' : _e, rest = __rest(_a, ["checked", "children", "className", "defaultChecked", "disabled", "id", "label", "name", "onBlur", "onChange", "onFocus", "fullWidth", "unselected", "variant"]);
    var _f = __read((0, react_1.useState)(false), 2), focused = _f[0], setFocused = _f[1];
    var handleFocus = function (event) {
        setFocused(true);
        onFocus && onFocus(event);
    };
    var handleBlur = function (event) {
        setFocused(false);
        onBlur && onBlur(event);
    };
    return ((0, jsx_runtime_1.jsxs)("label", __assign({ htmlFor: id, className: className, css: (0, Radio_style_1.default)(disabled, fullWidth, variant, unselected, focused) }, { children: [(0, jsx_runtime_1.jsx)("input", __assign({ id: id, ref: ref, name: name, type: 'radio', checked: checked, defaultChecked: defaultChecked, disabled: disabled, onChange: onChange, onFocus: handleFocus, onBlur: handleBlur }, rest)), variant === 'contained' ? (0, jsx_runtime_1.jsx)("span", __assign({ className: "radio-span" }, { children: label })) : label, children] })));
});
Radio.displayName = 'PrezzeeRadio';
exports.default = Radio;
//# sourceMappingURL=Radio.js.map